import React from "react";

const cards = [
  { title: "Step 1", desc: "Start your KYC by clicking the button above." },
  { title: "Step 2", desc: "Verify your identity using official documents." },
  { title: "Step 3", desc: "Complete the video KYC with our agent." },
  { title: "Step 4", desc: "Confirmation will be sent after completion." },
];

const InfoCards = () => (
  <section
    className="py-16 px-6"
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL}/MainBody04.png)`,
      backgroundSize: "cover",
    }}
  >
    <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((card, idx) => (
        <div
          key={idx}
          className="p-6 rounded-2xl text-center text-white transition transform hover:scale-105"
          style={{
            background: "rgba(0,0,0,0.65)",
            backdropFilter: "blur(10px)",
            boxShadow: "0 15px 30px rgba(0,0,0,0.6)",
          }}
        >
          <h3 className="text-xl font-semibold text-purple-400 mb-2">
            {card.title}
          </h3>
          <p className="text-gray-300 text-sm">{card.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default InfoCards;
